// src/pages/OngoingProjects.jsx
import React from 'react';
import PropertyListingPage from '../PropertyListing/PropertyListing';
import { Helmet } from 'react-helmet';

const OngoingProjects = () => {
  return(
    <>
          <Helmet>
            <title>Ongoing Projects</title>
            <meta name="description" content="Welcome to Gladious – experts in sustainable and modern construction projects." />
          </Helmet>
     <PropertyListingPage filterType="ongoing" pageTitle="Ongoing Projects" />;
 </> )
};

export default OngoingProjects;
